(function (angular) {
    'use strict';

    angular.module('apiSpaces')
        /**
         *
         */
        .controller('ApiSpaceCtrl',
            ['$scope', 'apiSpacesService', 'apiSpaceData', '$stateParams', 'growlService', 'apiSpacePicker', 'sweetAlertService', '$state',
                function ($scope, apiSpacesService, apiSpaceData, $stateParams, growlService, apiSpacePicker, sweetAlertService, $state) {
                    $scope.editing = false;
                    $scope.apiSpace = apiSpaceData;
                    $scope.updateData = function () {
                        $scope.formApiSpace = {
                            name: $scope.apiSpace.name,
                            description: $scope.apiSpace.description
                        };
                    };
                    $scope.deleteApiSpace = function () {
                        sweetAlertService.inputAlert(
                            "Are you sure?",
                            "You will not be able to recover this. Please enter the API Space name (" + $scope.apiSpace.name + ") below to confirm this action",
                            "Yes, delete it!",
                            "No",
                            $scope.apiSpace.name,
                            "Name isn't the same",
                            function (value) {
                                apiSpacesService.deleteApiSpace($scope.apiSpace.id).then(function (result) {
                                    $state.go('main.home').then(function() {
                                        apiSpacePicker.deleteApiSpace($scope.apiSpace);
                                    });
                                    swal("", "Your Api Space was successfully deleted", "success");
                                }).catch(function (error) {
                                    growlService.danger("Api Space wasn't deleted due to: " + error.statusText);
                                });
                            }
                        );
                    };
                    $scope.edit = function () {
                        $scope.editing = true;
                    };
                    $scope.updateData();
                    $scope.cancelUpdate = function () {
                        $scope.updateData();
                        $scope.editing = false;
                    };
                    $scope.update = function () {
                        apiSpacesService.updateApiSpace($stateParams.pickedApiSpaceId, $scope.formApiSpace.name, $scope.formApiSpace.description)
                            .then(function (config) {
                                $scope.apiSpace = config;
                                apiSpacePicker.updateApiSpace($scope.apiSpace);
                                $scope.editing = false;
                                growlService.success('Api Space configuration uploaded');

                            }).catch(function (error) {
                                $scope.updateData();
                                growlService.danger("Api Space configuration wasn't set due to: " + error.statusText);
                            });

                    };

                    $scope.copyToClipboard = function () {
                        var copyTextarea = document.querySelector('.apiSpaceId');
                        copyTextarea.select();
                        try {
                            document.execCommand('copy');
                            growlService.success('Api Space id copied to clipboard');
                        } catch (err) {
                            growlService.danger("Api Space id not copied, try manualy");
                        }
                    };
                }]);




})(window.angular);
